let sources = [
  {
    name: 'dFlowModel',
    type: 'gltfModel',
    path: ['/models/dflow.glb'],
  },

  {
    name: 'vennModel',
    type: 'gltfModel',
    path: ['/models/venn.glb'],
  },

  {
    name: 'sphereRingModel',
    type: 'gltfModel',
    path: ['/models/spheres.glb'],
  },

  {
    name: 'cardAlphaMap',
    type: 'texture',
    path: ['/textures/borders.jpg'],
  },

  {
    name: 'coinEth',
    type: 'texture',
    path: ['/textures/eth.png'],
  },

  {
    name: 'coinBtc',
    type: 'texture',
    path: ['/textures/btc.png'],
  },

  {
    name: 'coinSol',
    type: 'texture',
    path: ['/textures/sol.png'],
  },

  {
    name: 'coinTether',
    type: 'texture',
    path: ['/textures/tether.png'],
  },

  {
    name: 'coinRay',
    type: 'texture',
    path: ['/textures/ray.png'],
  },

  {
    name: 'coinOrca',
    type: 'texture',
    path: ['/textures/orca.png'],
  },

  {
    name: 'coinUsdc',
    type: 'texture',
    path: ['/textures/usdc.png'],
  },

  {
    name: 'coinSrm',
    type: 'texture',
    path: ['/textures/srm.png'],
  },

  {
    name: 'coinMango',
    type: 'texture',
    path: ['/textures/mango.png'],
  },

  {
    name: 'coinAudius',
    type: 'texture',
    path: ['/textures/audius.png'],
  },
]

export default sources
